"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.phoneNumberTokenLength = 6;
exports.refreshTokenLength = 128;
exports.conversationQuestionMin = 8;
exports.conversationQuestionMax = 256;
exports.messageContentMin = 0;
exports.messageContentMax = 1024;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NvbnN0YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFhLFFBQUEsc0JBQXNCLEdBQUcsQ0FBQyxDQUFBO0FBQzFCLFFBQUEsa0JBQWtCLEdBQUcsR0FBRyxDQUFBO0FBRXhCLFFBQUEsdUJBQXVCLEdBQUcsQ0FBQyxDQUFBO0FBQzNCLFFBQUEsdUJBQXVCLEdBQUcsR0FBRyxDQUFBO0FBRTdCLFFBQUEsaUJBQWlCLEdBQUcsQ0FBQyxDQUFBO0FBQ3JCLFFBQUEsaUJBQWlCLEdBQUcsSUFBSSxDQUFBIn0=